import React from 'react';
import { ClockIcon, MapPinIcon, ShieldCheckIcon, CheckCircleIcon } from 'lucide-react';
import { useLanguage } from '../context/LanguageContext';
const stats = [{
  labelKey: 'trust.experience.label',
  numKey: 'trust.experience.number',
  Icon: ClockIcon
}, {
  labelKey: 'trust.geography.label',
  Icon: MapPinIcon
}, {
  labelKey: 'trust.compliance.label',
  Icon: ShieldCheckIcon
}, {
  labelKey: 'trust.quality.label',
  Icon: CheckCircleIcon
}];
export function TrustStrip() {
  const {
    t
  } = useLanguage();
  return <section className="w-full bg-navy border-y border-slate-800/50" data-id="element-277">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8" data-id="element-278">
        <div className="grid grid-cols-2 lg:grid-cols-4 gap-6 lg:gap-4" data-id="element-279">
          {stats.map(stat => <div key={stat.labelKey} className="flex items-center gap-3" data-id="element-280">
              <div className="shrink-0 w-10 h-10 flex items-center justify-center rounded bg-electric/10" data-id="element-281">
                <stat.Icon className="w-5 h-5 text-electric" data-id="element-282" />
              </div>
              <div data-id="element-283">
                {stat.numKey && <div className="text-xl font-extrabold text-electric tracking-tight" data-id="element-284">
                    {t(stat.numKey)}
                  </div>}
                <div className="text-xs text-slate-400 uppercase tracking-wider font-medium leading-tight" data-id="element-285">
                  {t(stat.labelKey)}
                </div>
              </div>
            </div>)}
        </div>
      </div>
    </section>;
}